import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Timeline } from 'antd';
import PropTypes from 'prop-types';
import TimelineVersionItem from './TimelineVersionItem';
import FormTemplateVersionPreviewDrawer from './FormTemplateVersionPreviewDrawer';

import { getTemplateEvents } from '../state/forms.actions';

function FormTemplateTimeline({ templateId }) {
  const dispatch = useDispatch();
  const events = useSelector((state) => state.forms.templateEvents?.[templateId] || []);

  const [preview, setPreview] = useState(
    {
      open: false,
      versionId: null,
      versionNumber: null,
      isLatest: false,
      isLegacy: false,
      initialTab: 'fields',
    }
  )

  const onPreviewOpen = useCallback(({ versionId, versionNumber, isLatest, isLegacy, initialTab }) => {
    setPreview({
      open: true,
      versionId,
      versionNumber,
      isLatest,
      isLegacy,
      initialTab,
    });
  }, []);

  const onPreviewClose = useCallback(() => {
    setPreview({
      open: false,
      versionId: null,
      versionNumber: null,
      isLatest: false,
      isLegacy: false,
      initialTab: 'fields',
    });
  }, []);

  useEffect(() => {
    if (templateId) {
      dispatch(getTemplateEvents(templateId));
    }
  }, [templateId]);

  const onRestoreComplete = useCallback(() => {
    dispatch(getTemplateEvents(templateId));
  }, [templateId]);

  return (
    <div style={{ padding: '24px' }}>
      <Timeline>
        {events.length > 0 ? events.map((event) => (
          <TimelineVersionItem
            key={event.versionId}
            version={event}
            onPreviewOpen={onPreviewOpen}
          />
        )) : <div>No changes recorded yet.</div>}
      </Timeline>
      <FormTemplateVersionPreviewDrawer
        open={preview.open}
        onClose={onPreviewClose}
        templateId={templateId}
        versionId={preview.versionId}
        versionNumber={preview.versionNumber}
        isLatest={preview.isLatest}
        isLegacy={preview.isLegacy}
        initialTab={preview.initialTab}
        onRestoreComplete={onRestoreComplete}
      />
    </div>
  );
}

FormTemplateTimeline.propTypes = {
  templateId: PropTypes.string.isRequired,
};

export default FormTemplateTimeline;
